import { Flex } from 'antd';

import { ConditionView, Icon, Typography } from '@/shared/ui';

import { INSURANCE_SERVICE_ERROR_MESSAGES } from '../lib/constants';
import { InsuranceServiceError } from '../model/types';

export const InsuranceServiceErrorInformer: React.FC<{
  error: Nullable<InsuranceServiceError>;
}> = ({ error }) => {
  const { title, description } = error ? INSURANCE_SERVICE_ERROR_MESSAGES[error] : {};

  return (
    <ConditionView if={!!error}>
      <Flex vertical gap={16} style={{ position: 'absolute', top: '50%', transform: 'translateY(calc(-50% - 30px))' }}>
        <Icon name="process_error" color="red" width={40} height={40} />

        <Flex vertical gap={8}>
          <Typography variant="H3">{title}</Typography>
          <Typography>{description}</Typography>
        </Flex>
      </Flex>
    </ConditionView>
  );
};
